import type { FC } from "react";

import { useSelector } from "@jti/store/reduxHooks";
import { selectIsUserDataFetching } from "@jti/store/selectors/selectIsUserDataFetching";
import { type RootStoreState } from "@jti/store/types";
import { DEPRECATED_Loading } from "@jti/ui/components/DEPRECATED_Loading";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ImageBackgroundContainer } from "../../components/ImageBackgroundContainer/ImageBackgroundContainer";

import styles from "./AccountDashboardBanner.module.scss";

export type AccountDashboardBannerProps = {
  title: string;
  text: string;
  background: string;
  showCurrentTier: boolean;
  componentId?: string;
  tiers?: Record<string, string>;
};

const INITIAL_TIER_STATE = { name: "", image_url: "" };

export const AccountDashboardBanner: FC<AccountDashboardBannerProps> = ({
  title,
  text,
  background,
  showCurrentTier,
  componentId,
  tiers,
}) => {
  const points = useSelector((state: RootStoreState) => state.loyaltyCore.points.balance);
  const userTier = useSelector((state: RootStoreState) => state.loyaltyCore.tier);
  const isUserDataFetching = useSelector(selectIsUserDataFetching);
  const tier = showCurrentTier ? userTier : INITIAL_TIER_STATE;
  const { __ } = useTranslations();
  const tierNameToLowerCase = tier.name.toLowerCase();

  return (
    <ImageBackgroundContainer background={background} fullWidth>
      <div className={styles.container}>
        <div className={styles.firstSection}>
          <div className={styles.titleLight}>{title}</div>
        </div>
        <div className={styles.secondSection}>
          {!isUserDataFetching ? (
            <>
              <div className={styles.tiersAndPoints}>
                {!!tier.name && <div className={styles.smallText}>{__(tier.name)}</div>}
                <div className={styles.titleBold} data-testid={componentId}>
                  {String(points)}
                </div>
                <div className={styles.smallText}>{text}</div>
              </div>
              {showCurrentTier && tiers?.[tierNameToLowerCase] && (
                <img data-testid="tier-img" src={tiers?.[tierNameToLowerCase]} alt={__(tier.name) || ""} />
              )}
            </>
          ) : (
            <DEPRECATED_Loading whiteDots dataTestId="account-dashboard-banner-loading" />
          )}
        </div>
      </div>
    </ImageBackgroundContainer>
  );
};
